import { configureStore } from '@reduxjs/toolkit'
import { api, queryReducers } from 'mmfintech-checkout-commons'
import React from 'react'
import * as ReactDOMClient from 'react-dom/client'
import { Provider } from 'react-redux'

import './i18n'

import 'react-phone-input-2/lib/style.css'
import 'mmfintech-portal-commons/dist/main.css'
import './index.css'

import App from './App'

export const store = configureStore({
  reducer: queryReducers,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(api.middleware)
})

const root = ReactDOMClient.createRoot(document.getElementById('checkout-app'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
)
